module.exports = __webpack_public_path__ + "static/media/MobileGroupMobile.aa53edf7.png";